module.exports = __webpack_public_path__ + "2e4d08bc8dec95b56ab76be1dde8ba49.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/phyto/bpeel-b-logo.png
 ** module id = 200
 ** module chunks = 0
 **/